import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/estado/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function findEstado(empresa_cnpj) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
}

export function findEstadoById(empresa_cnpj, id) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}
